/** Personal per-client display preference. Effort never changes here. */
import { useEffect, useState } from "react";

export function reasoningDisplayKey(client: "web" | "desktop", workspaceId: string, userId: string): string {
  return `dayvise.reasoning-display:${JSON.stringify([client, workspaceId, userId])}`;
}
function read(key: string | null): boolean {
  try { return !key || localStorage.getItem(key) !== "hide"; } catch { return true; }
}
export function useReasoningDisplay(client: "web" | "desktop", workspaceId: string | null, userId: string | null): readonly [boolean, (show: boolean) => boolean] {
  const key = workspaceId && userId ? reasoningDisplayKey(client, workspaceId, userId) : null;
  const [value, setValue] = useState(() => ({ key, show: read(key) }));
  // Read the new scope on its first render; never flash the prior user's value.
  const show = value.key === key ? value.show : read(key);
  useEffect(() => {
    setValue({ key, show: read(key) });
    const refresh = (event: StorageEvent) => { if (event.key === key || event.key === null) setValue({ key, show: read(key) }); };
    window.addEventListener("storage", refresh);
    return () => window.removeEventListener("storage", refresh);
  }, [key]);
  return [show, (next) => {
    setValue({ key, show: next });
    if (!key) return false;
    try { localStorage.setItem(key, next ? "show" : "hide"); return true; } catch { return false; }
  }] as const;
}
